import { stats } from '@fiverr-private/obs';
import { METRICS_PREFIX } from './constants';

export default stats.prefix(METRICS_PREFIX);
